import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 403) {
      if (error.response.data?.error === 'Access revoked. Contact support.') {
        localStorage.removeItem('rankmyskills_college_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
